import { render, staticRenderFns } from "./AddNewOrder.vue?vue&type=template&id=3f4a4684&scoped=true&"
import script from "./AddNewOrder.vue?vue&type=script&lang=ts&"
export * from "./AddNewOrder.vue?vue&type=script&lang=ts&"
import style0 from "./AddNewOrder.vue?vue&type=style&index=0&id=3f4a4684&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4a4684",
  null
  
)

export default component.exports